"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeFilter = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var react_responsive_1 = tslib_1.__importDefault(require("react-responsive"));
var sdk_model_1 = require("@gooddata/sdk-model");
var AttributeDropdown_1 = require("./AttributeDropdown/AttributeDropdown");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var constants_1 = require("../constants");
var AttributeFilterUtils_1 = require("./utils/AttributeFilterUtils");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var json_stable_stringify_1 = tslib_1.__importDefault(require("json-stable-stringify"));
var DefaultFilterError = react_intl_1.injectIntl(function (_a) {
    var intl = _a.intl;
    var text = intl.formatMessage({ id: "gs.filter.error" });
    return react_1.default.createElement("div", { className: "gd-message error s-button-error" }, text);
});
var AttributeFilterCore = function (props) {
    ts_invariant_1.default(!(props.filter && props.connectToPlaceholder), "It's not possible to combine 'filter' property with 'connectToPlaceholder' property. Either provide a value, or a placeholder.");
    ts_invariant_1.default(!(props.filter && !props.onApply), "It's not possible to use 'filter' property without 'onApply' property. Either provide 'onApply' callback or use placeholders.");
    var locale = props.locale, workspace = props.workspace, backend = props.backend, _a = props.FilterError, FilterError = _a === void 0 ? DefaultFilterError : _a, title = props.title, _b = props.titleWithSelection, titleWithSelection = _b === void 0 ? false : _b, _c = props.fullscreenOnMobile, fullscreenOnMobile = _c === void 0 ? false : _c, identifier = props.identifier, filter = props.filter, parentFilters = props.parentFilters, connectToPlaceholder = props.connectToPlaceholder, parentFilterOverAttribute = props.parentFilterOverAttribute, _d = props.onError, onError = _d === void 0 ? sdk_ui_1.defaultErrorHandler : _d, onApply = props.onApply;
    var resolvedParentFilters = sdk_ui_1.useResolveValueWithPlaceholders(parentFilters);
    var _e = sdk_ui_1.usePlaceholder(connectToPlaceholder), resolvedPlaceholder = _e[0], setPlaceholderValue = _e[1];
    var currentFilter = resolvedPlaceholder || filter;
    var getBackend = function () {
        return backend.withTelemetry("AttributeFilter", props);
    };
    var _f = sdk_ui_1.useCancelablePromise({
        promise: function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var attributes, displayForm, attribute;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        attributes = getBackend().workspace(workspace).attributes();
                        return [4 /*yield*/, attributes.getAttributeDisplayForm(AttributeFilterUtils_1.getObjRef(currentFilter, identifier))];
                    case 1:
                        displayForm = _a.sent();
                        return [4 /*yield*/, attributes.getAttribute(displayForm.attribute)];
                    case 2:
                        attribute = _a.sent();
                        return [2 /*return*/, attribute.title];
                }
            });
        }); },
    }, [identifier, workspace]), attributeTitle = _f.result, attributeError = _f.error, attributeStatus = _f.status;
    var _g = sdk_ui_1.useCancelablePromise({
        promise: function () { return AttributeFilterUtils_1.getParentFilterTitles(resolvedParentFilters !== null && resolvedParentFilters !== void 0 ? resolvedParentFilters : [], getBackend(), props.workspace); },
    }, [props.backend, props.workspace, json_stable_stringify_1.default(resolvedParentFilters)]), parentFilterTitlesError = _g.error, parentFilterTitles = _g.result, parentFilterTitlesStatus = _g.status;
    var onFilterApply = function (selectedItems, isInverted) {
        var useUriElements = currentFilter && sdk_model_1.isAttributeElementsByRef(sdk_model_1.filterAttributeElements(currentFilter));
        var filterFactory = isInverted ? sdk_model_1.newNegativeAttributeFilter : sdk_model_1.newPositiveAttributeFilter;
        var filter = filterFactory(AttributeFilterUtils_1.getObjRef(currentFilter, identifier), useUriElements
            ? { uris: selectedItems.map(function (item) { return item.uri; }) }
            : { values: selectedItems.map(function (item) { return item.title; }) });
        if (connectToPlaceholder) {
            setPlaceholderValue(filter);
        }
        return onApply === null || onApply === void 0 ? void 0 : onApply(filter);
    };
    react_1.useEffect(function () {
        if (attributeError || parentFilterTitlesError) {
            onError(attributeError || parentFilterTitlesError);
        }
    }, [attributeError, parentFilterTitlesError]);
    var getInitialDropdownSelection = function () {
        if (!currentFilter) {
            return {
                isInverted: true,
                selectedItems: [],
            };
        }
        var elements = sdk_model_1.filterAttributeElements(currentFilter);
        return {
            isInverted: !sdk_model_1.isPositiveAttributeFilter(currentFilter),
            selectedItems: AttributeFilterUtils_1.attributeElementsToAttributeElementArray(elements),
        };
    };
    var _h = getInitialDropdownSelection(), selectedItems = _h.selectedItems, isInverted = _h.isInverted;
    return (react_1.default.createElement(sdk_ui_1.IntlWrapper, { locale: locale }, attributeError || parentFilterTitlesError ? (react_1.default.createElement(FilterError, { error: attributeError || parentFilterTitlesError })) : (react_1.default.createElement(react_responsive_1.default, { query: constants_1.MediaQueries.IS_MOBILE_DEVICE }, function (isMobile) { return (react_1.default.createElement(sdk_ui_1.IntlTranslationsProvider, null, function (translationProps) {
        return (react_1.default.createElement(AttributeDropdown_1.AttributeDropdown, { titleWithSelection: titleWithSelection, displayForm: AttributeFilterUtils_1.getObjRef(currentFilter, identifier), backend: backend, workspace: workspace, onApply: onFilterApply, title: title || attributeTitle, isInverted: isInverted, selectedItems: selectedItems, isLoading: attributeStatus === "pending" ||
                attributeStatus === "loading" ||
                parentFilterTitlesStatus == "pending" ||
                parentFilterTitlesStatus === "loading", translationProps: translationProps, isMobile: isMobile, fullscreenOnMobile: fullscreenOnMobile, parentFilters: AttributeFilterUtils_1.getValidElementsFilters(resolvedParentFilters, parentFilterOverAttribute), parentFilterTitles: parentFilterTitles }));
    })); }))));
};
/**
 * AttributeFilter is a component that renders a dropdown populated with attribute values
 * for specified attribute display form.
 *
 * @public
 */
exports.AttributeFilter = sdk_ui_1.withContexts(AttributeFilterCore);
//# sourceMappingURL=AttributeFilter.js.map